<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name express_top flex-r-sb-c"
         style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;"
    >
      <van-icon name="arrow-left" @click="backPath" />
      <div v-for="(packet_item,packet_index) in packetList" :key="packet_index"
           :class=" packet_index === choosed?'top_name express_name express_actived':'top_name express_name ' "
           @click="choosePacket(packet_item,packet_index)"
      >
        包裹{{ packet_index+1 }}
      </div>
      <div v-if="packetList.length>0" />
    </div>
    <!-- 商品信息 -->
    <div class="express_pro_list">
      <div v-for="(pro_item,pro_index) in showproList" :key="pro_index" class="pro_list_item ">
        <div class="flex-r-sb-c">
          <div class="item_info flex-c-s-c">
            <div class="item_name">{{ pro_item.name }}</div>
            <div class="item_msg">{{ pro_item.brand }} | {{ pro_item.specifications }}</div>
          </div>
          <div class="item_num">数量：{{ pro_item.realNum }}</div>
        </div>
        <van-divider />
      </div>
      <div v-if="proList.length>2" class="express_pro_more" @click="showAll">
        <span>{{ isAll?'收起商品':'展开全部' }}</span>
        <van-icon :name="isAll?'arrow-up':'arrow-down'" />
      </div>
    </div>
    <!-- 物流信息 -->
    <div class="express_info">
      <div class="express_name"> {{ expressStep.expressName }}：{{ expressStep.expressNo }} </div>
      <van-divider />
      <van-steps direction="vertical" :active="0" active-color="#0767AB" active-icon="map-marked"
                 inactive-icon="checked"
      >
        <van-step v-for="(step_item,step_index) in expressStep.expressItemList" :key="step_index" class="express_step">
          <!-- <div class="step_status">派送中</div> -->
          <div class="step_msg">{{ step_item.remark }}</div>
          <div class="step_time">{{ step_item.acceptTime }}</div>
        </van-step>
      </van-steps>
      <br>
    </div>
  </div>
</template>

<script>
import './index.scss'
import { mallOrder_orderExpressList, mallOrder_orderExpressProductList } from '@/api/order'
export default {
  data() {
    return {
      orderId: '',
      choosed: 0,
      packetList: [],
      showproList: [],
      proList: [],
      isAll: false,
      expressStep: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.getExpressList()
  },
  methods: {
    // 获取列表
    getExpressList() {
      mallOrder_orderExpressList({ page: 1, limit: 10, orderId: this.orderId }).then(res => {
        this.packetList = res.data.list
        const item = { orderExpressId: res.data.list[0].orderExpressId }
        this.choosePacket(item, 0)
      })
    },
    choosePacket(item, index) {
      this.choosed = index
      mallOrder_orderExpressProductList({ page: 1, limit: 9999, orderId: this.orderId, orderExpressId: item.orderExpressId }).then(res => {
        this.proList = res.data.list
        if (res.data.list.length > 2) {
          this.showproList = [this.proList[0], this.proList[1]]
        } else {
          this.showproList = res.data.list
        }
        this.expressStep = this.packetList[index]
      })
    },
    backPath() { window.history.back() },
    // 商品展开事件
    showAll() {
      this.isAll = !this.isAll
      this.showproList = this.isAll ? this.proList : [this.proList[0], this.proList[1]]
    }
  }
}
</script>

<style>
</style>
